import useIsMobile from 'src/hooks/useIsMobile';
import useIsPdfPage from 'src/hooks/useIsPdfPage';
import useQuoteTemplate from 'src/hooks/useQuoteTemplate';

const useSecondaryHeroVisible = (): boolean => {
    const isMobile = useIsMobile();
    const isPdfPage = useIsPdfPage();
    const { isSafariLayout } = useQuoteTemplate();

    return !isMobile && (isSafariLayout || isPdfPage);
};

export default useSecondaryHeroVisible;
